// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app h5[data-v-21472390]{margin-bottom:1rem}#app .quality-line[data-v-21472390]{line-height:2em;padding:.5rem 0;cursor:pointer}#app .quality-line.on[data-v-21472390]{font-weight:700}#app .quality-line.on[data-v-21472390],#app .quality-line[data-v-21472390]:hover{background-color:#f8f8f8}", ""]);
// Exports
module.exports = exports;
